import { put, takeEvery, all } from 'redux-saga/effects';
import * as constants from '../constants/all';
import * as mainMenuActions from '../actions/mainMenu';
import { Log } from 'ng2-logger';
import { MainMenuService } from '../../api/main-menu-service';
import { Common } from '../../core/common';
import * as coreActions from '../actions/core';
import Translator from '../../core/i18n';
const T = Translator.create();
const _logger = Log.create('MainMenu Sagas');
const mainMenuService = new MainMenuService();

function* setMainMenuData(params: any): any {
    const common = new Common();
    try {
        yield put(mainMenuActions.setMainMenuData([]));
        const pageData = yield mainMenuService.RequestGetMainMenuAsync().then((responseData: Response) => {
            return responseData;
        }).then((data: any | null) => {
            return data;

        });
        yield put(mainMenuActions.setMainMenuData(pageData, params.spinnerId, 'set'));
    } catch (error: any) {
        yield put(mainMenuActions.setMainMenuData([], params.spinnerId, 'set'));
    }
}

function* setMainMenuCourseTabData(params: any): any {
    const common = new Common();
    try {
        let pageData = yield mainMenuService.RequestGetMainMenuCourseTabAsync().then((responseData: Response) => {
            return responseData;
        }).then((data: any | null) => {
            return data;
        });
        let activeStatus = 0;
        // tslint:disable-next-line: prefer-const
        let courseSubNavigationParam = null;
        if (pageData !== null && pageData.length > 0) {
            courseSubNavigationParam = pageData[0];
            if (pageData[0].type.toString() === '5') { activeStatus = 2; } else if (pageData[0].type.toString() === '4') { activeStatus = 0; } else {
                activeStatus = 1;
            }
        } else {
            pageData = [];
        }
        // tslint:disable-next-line: prefer-const
        let type = '';
        if (courseSubNavigationParam !== null) {
            type = courseSubNavigationParam.type;
        }
        yield put(mainMenuActions.setMainMenuCourseTabData(pageData, activeStatus, type, true));
    } catch (error: any) {
        yield put(mainMenuActions.setMainMenuCourseTabData(null, null, null, true));

    }
}

function* setMainMenuCourseContentData(params: any): any {
    const common = new Common();
    try {
        yield put(mainMenuActions.setMainMenuCourseContentData([]));
        const pageData = yield mainMenuService.RequestGetMainMenuCourseContentAsync(params.isTeacher, params.activeStatus, params.courseSubNavigationParam).then((responseData: Response) => {
            return responseData;
        }).then((data: any | null) => {
            return data;
        });
        yield put(mainMenuActions.setMainMenuCourseContentData(pageData, params.spinnerId, 'set'));
    } catch (error: any) {
        yield put(mainMenuActions.setMainMenuCourseContentData([], params.spinnerId, 'set'));

    }
}

export function* watchGetMainMenuData() {
    yield takeEvery(constants.mainMenuActions.GET_MAIN_MENU_DATA, setMainMenuData);
    return null;
}
export function* watchGetMainMenuCourseTabData() {
    yield takeEvery(constants.mainMenuActions.GET_MAIN_COURSEMENU_TAB_DATA, setMainMenuCourseTabData);
    return null;
}

export function* watchGetMainMenuCourseContentData() {
    yield takeEvery(constants.mainMenuActions.GET_MAIN_COURSEMENU_CONTENT_DATA, setMainMenuCourseContentData);
    return null;
}

export function* MainMenuSagas() {
    yield all([
        watchGetMainMenuData(),
        watchGetMainMenuCourseTabData(),
        watchGetMainMenuCourseContentData()
    ]);
}
